$(function() {
    "use strict";

    var $profileCoupon = $('.profile__coupon');

    $(document).on('click', '.profile__coupon__toggle-button', function(e) {
        e.preventDefault();


        $profileCoupon.toggleClass('profile__coupon_hidden');
    });
});